import StatsInfo from './StatsInfo';

export default StatsInfo;
